import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api, ApiError } from '../api/client.js';

type State = { kind: 'loading' } | { kind: 'success' } | { kind: 'error'; message: string };

/**
 * Einladungs-Landing (Modus B). Löst den Token aus dem Link ein, legt die
 * Session an und leitet direkt ins Onboarding (inkl. ggf. zugewiesenem
 * Fragebogen). Die Sprache folgt ?lng=… aus dem Einladungslink.
 */
export function Invite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [state, setState] = useState<State>({ kind: 'loading' });
  const consumedRef = useRef(false);

  useEffect(() => {
    if (consumedRef.current) return;
    consumedRef.current = true;
    const token = params.get('token');
    if (!token) {
      setState({ kind: 'error', message: t('invite.errorInvalid') });
      return;
    }
    (async () => {
      try {
        await api.inviteConsume(token);
        setState({ kind: 'success' });
        // Einladung = fallspezifischer Intake → getrennte Route /intake
        setTimeout(() => navigate('/intake', { replace: true }), 1200);
      } catch (err) {
        const message = err instanceof ApiError && err.code === 'invalid_or_expired_token'
          ? t('invite.errorInvalid')
          : t('invite.errorGeneric');
        setState({ kind: 'error', message });
      }
    })();
  }, [params, navigate, t]);

  return (
    <div className="card">
      {state.kind === 'loading' && (
        <>
          <h2 className="card-title">{t('invite.checkingTitle')}</h2>
          <p className="card-subtitle">{t('invite.wait')}</p>
        </>
      )}
      {state.kind === 'success' && (
        <>
          <h2 className="card-title">{t('invite.successTitle')}</h2>
          <div className="alert alert-success">{t('invite.successBody')}</div>
        </>
      )}
      {state.kind === 'error' && (
        <>
          <h2 className="card-title">{t('invite.errorTitle')}</h2>
          <div className="alert alert-error">{state.message}</div>
          <p className="muted-block">
            <Link to="/login" className="text-link">{t('invite.loginLink')}</Link>
          </p>
        </>
      )}
    </div>
  );
}
